export default class PhotoSwipeTheme {
    constructor(gallery) {
        if (!gallery) return;

        this.gallery = gallery;
        this.settings = gallery.dataset.photoswipeOptions;
        this.links = this.gallery.querySelectorAll('a');
        this.modal = document.querySelector('.pswp');
        this.items = [];

        if (this.settings) {
            this.settings = JSON.parse(this.settings);
        }

        this.init();
        this.events();
    }

    getItems() {
        let temp_items = [];
        this.links.forEach(pic_item => {
            temp_items.push({
                src: pic_item.dataset.src,
                w: pic_item.dataset.width,
                h: pic_item.dataset.height,
                msrc: pic_item.querySelector('img').getAttribute('src'),
                title: pic_item.dataset.title,
                pid: pic_item.dataset.slug
            });

        });
        return temp_items;
    }

    init() {
        this.settings = Object.assign({
            closeOnScroll: true,
            escKey: true,
            arrowKeys: true,
            loop: true,
            history: true,
            focus: true,
            modal: true,
            showHideOpacity: true,
            closeEl: true,
            captionEl: true,
            fullscreenEl: true,
            zoomEl: true,
            shareEl: true,
            counterEl: true,
            arrowEl: true,
            preloaderEl: true,
            bgOpacity: 0.7,
        }, this.settings);
        // this.items = this.getItems.bind(this)();

        this.links.forEach(pic_item => {
            this.items.push({
                src: pic_item.dataset.src,
                w: pic_item.dataset.width,
                h: pic_item.dataset.height,
                msrc: pic_item.querySelector('img').getAttribute('src'),
                title: pic_item.dataset.title,
                pid: pic_item.dataset.slug
            });
        });
    }

    onLinkClick(ev) {
        ev.preventDefault();
        const linkOptions = {
            index: parseInt( ev.currentTarget.dataset.index ),
            bgOpacity: this.settings.bgOpacity,
            spacing: 0.12,
            allowPanToNext: true,
            pinchToClose: true,
            closeOnScroll: this.settings.closeOnScroll,
            closeOnVerticalDrag: true,
            escKey: this.settings.escKey,
            arrowKeys: this.settings.arrowKeys,
            history: this.settings.history,
            mouseUsed: false,
            loop: this.settings.loop,
            focus: this.settings.focus,
            modal: this.settings.modal,
            showHideOpacity: this.settings.showHideOpacity,
            showAnimationDuration: 333,
            hideAnimationDuration: 333,
            closeEl: this.settings.closeEl,
            captionEl: this.settings.captionEl,
            fullscreenEl: this.settings.fullscreenEl,
            zoomEl: this.settings.zoomEl,
            shareEl: this.settings.shareEl,
            counterEl: this.settings.counterEl,
            arrowEl: this.settings.arrowEl,
            preloaderEl: this.settings.preloaderEl,
        };

		if ('function' === typeof PhotoSwipe && 'null' !== typeof this.modal) {
            let lightBox = new PhotoSwipe(this.modal, PhotoSwipeUI_Default, this.items, linkOptions);
            lightBox.init();
        }
    }

    events() {
        this.links.forEach(link => {
            link.addEventListener('click', this.onLinkClick.bind(this), false);
        });
    }
}
